import axios from "axios";
import HTTP_BASE_URL from "../constants/HttpConstants";
const api = axios.create({
  baseURL: HTTP_BASE_URL, // Change base URL as needed
});

api.interceptors.request.use((config) => {
  const token = "508b1430-68f0-4b2f-9003-3c2a0eb2a54a";
  const customertoken = localStorage.getItem("customertoken");
  if (token && customertoken) {
    config.headers["access-token"] = `${token}`;
    config.headers.customertoken = `${customertoken}`;
  }
  return config;
});

export default api;
